var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useRef } from "react";
/** Invalidates in-flight plaintext responses on context change or unmount. */
export function useSecretRevealGuard(context, allowed) {
    var scope = useRef({ context: context, allowed: allowed });
    if (scope.current.context !== context || scope.current.allowed !== allowed) {
        scope.current = { context: context, allowed: allowed };
    }
    useEffect(function () { return function () {
        scope.current = __assign({}, scope.current);
    }; }, []);
    return function () {
        var requestScope = scope.current;
        return function () { return requestScope.allowed && scope.current === requestScope; };
    };
}
